const navbar = [
  {
      href: "/",
      label: "Home",
  },
  {
      href: "/about",
      label: "About",
  },
  {
      href: "/services",
      label: "Services",
  },
  {
      href: "/gallery",
      label: "Gallery",
  },
]

const footer = {
  "Меню": [
    {
        href: "/",  
        label: "Home",
    },
    {
        href: "/about",
        label: "About",
    },
    {
        href: "/services",
        label: "Services",
    }
  ],
  "Помощ": [
      {
          href: "/privacy-policy",
          label: "Privacy Policy",
      },
      {
          href: "/terms",
          label: "Terms & Conditions",
      },
  ]
}
export { navbar, footer }